import { useState } from "react";
import EditContractType from "./EditContractType";
import NewContractTypeForm from "./NewContractTypeForm";
import { ContractTypeDto } from "../../../../../models/contract-type.dto";
import { useGetContractType } from "../../../../../services/contract-type.service";
import { AiOutlinePlus } from "react-icons/ai";
import useUserStore from "../../../../../state-management/useUserStore";
import { SkewLoader } from "react-spinners";
import CustomPagination from "../../../../../components/table/CustomPagination";
import { useCheckUserPermissions, PermissionChecker, PERMISSIONS } from "../../../../../helpers/usePermissionManager";
import { useManageTableWithStateVariables } from "../../../../../helpers/useManageTable";

const ContractTypes = () => {
	const { currentUser } = useUserStore();
	const { checkUserPermissionsAnd } = useCheckUserPermissions();
	const [showNewContractTypeForm, setShowNewContractTypeForm] = useState(false);
			
	const {
		tableData: contractTypes,
		isLoading,
		page,
		pageCount,
		addNewData,
		reloadData,
		handlePageChange,
	} = useManageTableWithStateVariables<ContractTypeDto>({ 
		fetchHook: useGetContractType,
		options: {
			organizationId: currentUser.user.organizationId,
			limit: 8,
		}
	});
	
	return (
		<div className="mb-4">
			<div className="border-b-[1.5px] pb-3 mb-4 flex w-full justify-between text-sm">
				<h2 className="font-semibold">Available Contract Types</h2>
				{!showNewContractTypeForm && (
					<PermissionChecker permissions={[PERMISSIONS.ORG_CONFIGS_COMPANY_WRITE]}>
						<button
							onClick={() => setShowNewContractTypeForm(true)}
							className="border-none flex items-center text-primary-blue"
						>
							<AiOutlinePlus className="mr-2 text-lg" />
							Add New Contract Type
						</button>
					</PermissionChecker>
				)}
			</div>

			{showNewContractTypeForm && (
				<NewContractTypeForm
					setShowNewContractTypeForm={setShowNewContractTypeForm}
					addNewData={addNewData}
				/>
			)}

			{(isLoading && !contractTypes.length && checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ])) && (
				<div className="text-center mt-10 py-10">
					<SkewLoader color="#F58B00" />
				</div>
			)}

			{contractTypes.map((contractType) => (
				<EditContractType
					key={contractType.id}
					contractType={contractType}
					reloadData={reloadData}
				/>
			))}

			{(!isLoading && !contractTypes.length && checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ])) && (
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						Sorry no contract types added yet. Click 'Add New Contract Type' to begin.
					</h3>
				</div>
			)}

			{checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ]) ? (
				<div className="w-full flex justify-end my-8">
					<CustomPagination 
						pageCount={pageCount} 
						pageState={page}
						handleChange={handlePageChange}
					/>
				</div>
			):(
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						You are not authorized to access this data.
					</h3>
				</div>
			)}
		</div>
	);
};

export default ContractTypes;
